<div class="access-card" [class.expanded]="expanded">
  <div class="card-header" (click)="toggleExpanded()">
    <div class="card-title">
      <div class="title-icon" [class.success]="successfullyConnected">
        @if (successfullyConnected) {
          <i class="fa-solid fa-check"></i>
        }
        @if (!successfullyConnected && accessType === 'source') {
          <i class="fa-solid fa-location-dot"></i>
        }
        @if (!successfullyConnected && accessType === 'target') {
          <i class="fa-solid fa-location-crosshairs"></i>
        }
        @if (!successfullyConnected && accessType === 'failback') {
          <i class="fa-solid fa-rotate-left"></i>
        }
      </div>
      <div>
        <h3>{{ title }}</h3>
        <div class="card-subtitle">
          <code>{{ subscriptionId }}</code> / <code>{{ region }}</code>
        </div>
      </div>
    </div>
    <div class="card-actions">
      <div class="card-action" (click)="$event.stopPropagation()">
        @if (successfullyConnected) {
          <span class="success-badge"><i class="fa-solid fa-circle-check"></i> Connected</span>
        } @else {
          <button class="arpio-button" [disabled]="testing" (click)="testButtonClick()">
            @if (testing) {
              <i class="fa-solid fa-spinner fa-spin"></i> TESTING...
            } @else {
              TEST ACCESS
            }
          </button>
        }
      </div>
      <i class="fa-solid chevron-icon" [class.fa-chevron-down]="expanded" [class.fa-chevron-right]="!expanded"></i>
    </div>
  </div>

  @if (!successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body">
        <p class="instruction-text">
          @if (retryText) {
            <strong class="retry-text">{{ retryText }}</strong>
          }
          Execute the following command to grant {{ uiService.productName }} access to your Azure subscription:
        </p>
        <div class="command-block">
          <button class="copy-btn" [copy-clipboard]="installCommand" (copied)="onCopied()">
            <i class="fa-utility fa-semibold" [class.fa-copy]="!copied" [class.fa-check]="copied"></i>
            {{ copied ? 'Copied!' : 'Copy' }}
          </button>
          <pre><code>{{ installCommand }}</code></pre>
        </div>
      </div>
    </div>
  }

  @if (successfullyConnected) {
    <div class="card-body-wrapper" [@slideDown]="expanded ? 'expanded' : 'collapsed'">
      <div class="card-body success-body">
        <div class="success-message">
          <i class="fa-solid fa-circle-check"></i>
          <span>Access configured successfully</span>
        </div>
      </div>
    </div>
  }
</div>
